import { motion } from 'framer-motion';
import styled from 'styled-components';

import Text from '~components/Text';

export const S = {
  Container: styled(motion.nav)`
    position: fixed;
    width: 320px;
    height: 268px;
    left: 0;
    bottom: 40px;

    z-index: 10;

    ${({ theme }) => theme.media.mobile} {
      width: 100%;
      height: auto;

      left: 0;
      bottom: 0;
      right: 0;
    }
  `,
  Wrapper: styled.div`
    background-color: #f0cfda;
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 24px;
    text-align: center;

    ${({ theme }) => theme.media.mobile} {
      display: flex;
      align-items: center;
      height: 56px;
      padding: 0 12px;
      margin: 16px;
    }
  `,
  ImgWrapper: styled.div`
    img {
      vertical-align: top;
    }
  `,
  IconWrapper: styled.div`
    position: absolute;
    right: 19px;
    top: 19px;

    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 350%;
      height: 250%;
    }
  `,
  Img: styled.img`
    width: 272px;
    height: 132px;

    ${({ theme }) => theme.media.mobile} {
      width: 56px;
      height: 56px;
    }
  `,
  Text: styled(Text)`
    display: block;
    margin: 12px 0;
    color: ${({ theme }) => theme.colors.magenta900};

    ${({ theme }) => theme.media.mobile} {
      margin: 0;
      margin-left: 4px;
    }
  `,
  ButtonWrapper: styled.div`
    ${({ theme }) => theme.media.mobile} {
      display: flex;
      flex: auto;
      justify-content: flex-end;
    }
  `,
};
